export const UNITS = [['empaque', 'Amevel Empaques'], ['foods', 'Amevel Foods'], ['coffee_vending', 'Coffee & Vending Panamá']];
export async function fileData(file) {
    return new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(String(reader.result).split(',')[1]); reader.onerror = reject; reader.readAsDataURL(file); });
}
export function saveBlob(blob, name) {
    const url = URL.createObjectURL(blob), link = document.createElement('a'); link.href = url; link.download = name; link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function panamaDate(value) { return value ? new Date(value).toLocaleString('es-PA', { timeZone: 'America/Panama' }) : '—'; }
export function purchasingQuery() {
    const hash = window.location.hash || '';
    return new URLSearchParams(hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : window.location.search);
}

export const documentDate = value => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(Number(value.slice(0,4)),Number(value.slice(5,7))-1,Number(value.slice(8,10))).toLocaleDateString('es-PA') : panamaDate(value);
export const usd = value => value == null ? 'Pendiente' : Number(value).toLocaleString('es-PA', {style: 'currency', currency: 'USD'});
